import React from 'react';
import Navbar from '../../../containers/Navbar/Navbar.jsx';
import HeaderContent from './HeaderContent/HeaderContent.jsx';
import HeroSVG from '../../../../assets/Hero-SVG3.svg';
import style from './HeroSection.module.css';


const HeroSection = () => {
    return (
        <div className={`${style.heroSection} shadow-lg`}>
            <Navbar />
            <main className={`${style.heroMain} container`}>
                <HeaderContent />
                <div className={style.heroSVGContainer}>
                    <img src={HeroSVG} alt="hero-svg"/>
                </div>
            </main>
        </div>
    )
}

export default HeroSection
